import { axiosAiq } from 'config';
import axios from 'axios';

export const transactionMediaPresign = async (payload) => {
    const response = await axiosAiq.post('/transaction/media/presign', payload);
    return response.data;
};

export const uploadImageToS3 = async (presignPutUrl, file) => {
    if (!presignPutUrl) throw new Error('[SAVE_TRANSACTION_IMAGE] presignPutUrl is missing!');
    if (!file || !file.type) throw new Error('[SAVE_TRANSACTION_IMAGE] file is missing or not a valid File/Blob!');
    return axios.put(presignPutUrl, file, {
        headers: {
            'Content-Type': file.type,
        },
        timeout: 15000,
    });
};

export const transactionMediaConfirm = async (payload) => {
    const response = await axiosAiq.put('/transaction/media/confirm', payload);
    return response.data;
};

export const transactionMediaClose = async (transactionId, payload) => {
    const response = await axiosAiq.put(`/transaction/${transactionId}/media/close`, payload);
    return response.data;
};

export const transactionMediaDelete = async (assetIds) => {
    const response = await axiosAiq.delete('/transaction/media', { data: { assetIds } });
    return response.data;
};
